export const normalizarClaveDocente = (nombre) =>
  String(nombre ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, " ");

export const normalizarNombreDocente = (nombre) => normalizarClaveDocente(nombre);
